const HorizontalLine = () => (
  <div className="relative flex items-center pt-2">
    <div className="grow border-t border-gray-400" />
  </div>
);

export default HorizontalLine;
